import { h } from 'preact'; /** @jsx h */
import { forwardRef } from 'preact/compat';

/*
 * DRY input that prevents autocomplete on inputs without having to copy-paste quirks everywhere
 */
const NoAutoCompleteInput = forwardRef((props, ref) => {
    return (
        <input
            {...props}
            ref={ref}
            autoComplete="off" // Standard browser disable
            aria-autocomplete="none" // Newer versions of Edge disable
        />
    );
});

export default NoAutoCompleteInput;
